import React from 'react';
import { action, makeObservable, observable } from 'mobx';
import { RefObject } from 'react';
import RootStore from './RootStore';

export default class LayoutStore {
  private rootStore: RootStore;

  @observable
  contentDivRef: RefObject<HTMLDivElement> = React.createRef();
  @observable isSuccessPopUpVisibile: boolean = false;
  @observable popupMessage: string = '';
  @observable isWide: boolean = true;

  @action
  setWide = (isWide: boolean) => {
    this.isWide = isWide;
  };

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    makeObservable(this);
  }
}
